import {
  getAbsoluteAudioPath,
  getAbsoluteImagePath,
} from '@/shared/Activities/RealTimeActivity/Players/SortImagesActivity/sortImages.utils';
import Image from 'next/image';
import QuestionAudio from 'src/components/studentPages/StudentRealTimeActivity/activityTypes/StudentSortImagesActivity/SortPanel/QuestionAudio/QuestionAudio';
import { StyledQuestionCard } from './QuestionCard.styled';
import Button from '@/shared/Button/Button';
import { InfoOutlined } from '@ant-design/icons';
import useQuestionCard from './useQuestionCard.hook';
import AspectRatio from '@/shared/AspectRatio/AspectRatio';

export default function QuestionCard({
  question,
  folder,
  onAudioPlaying,
  onAudioEnded,
  className = '',
  disabled = false,
}) {
  const { state, actions } = useQuestionCard();

  return (
    <StyledQuestionCard className={className}>
      <QuestionAudio
        audioId={question.id}
        audio={
          folder ? getAbsoluteAudioPath(folder, question.audio) : question.audio
        }
        disabled={disabled}
        onPlay={onAudioPlaying}
        onEnded={onAudioEnded}
      />
      {question.englishText ? (
        <Button
          type={state.showEnglishText ? 'pink' : ''}
          size="small"
          shape="circle"
          icon={<InfoOutlined />}
          className="question-card-translate-button"
          onClick={actions.toggleShowEnglishText}
        />
      ) : null}
      <div className="question-card-text">
        <span>{question.text}</span>
        {state.showEnglishText ? (
          <span className="showing-answer">{question.englishText}</span>
        ) : null}
      </div>
      <div className="question-card-image">
        <AspectRatio ratio={16 / 9}>
          <Image
            src={
              folder
                ? getAbsoluteImagePath(folder, question.image)
                : question.image
            }
            alt={question.text}
            layout="fill"
            objectFit="cover"
          />
        </AspectRatio>
      </div>
    </StyledQuestionCard>
  );
}
